module.exports = __webpack_public_path__ + "img/t6-1.3c46d4ab.svg";